// extracted by mini-css-extract-plugin
export default {"container":"AdminSettings_container__ER1ZA","card":"AdminSettings_card__1b+3D","settingRow":"AdminSettings_settingRow__XXKIn"};